import { render, staticRenderFns } from "./ProjectConfigurationMailingOptions.vue?vue&type=template&id=e0d6b458&"
import script from "./ProjectConfigurationMailingOptions.vue?vue&type=script&lang=js&"
export * from "./ProjectConfigurationMailingOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports